export default {
  name: "TicketSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m30.48 10.61-2.1-2.1a1 1 0 0 0-1.09-.22c-1.39.58-2.54-.41-2.85-.73s-1.31-1.46-.73-2.85a1 1 0 0 0-.22-1.09L21.4 1.53a2.05 2.05 0 0 0-2.83 0L1.52 18.57a1.98 1.98 0 0 0 0 2.81l2.1 2.1a1 1 0 0 0 1.09.22c1.39-.58 2.54.41 2.85.73.32.32 1.31 1.46.73 2.85-.16.37-.07.8.22 1.09l2.09 2.09a2 2 0 0 0 2.82 0l17.05-17.05c.38-.38.58-.88.58-1.41a1.91 1.91 0 0 0-.57-1.39zM16 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6z",
  },
}
